import { Box, IconButton, Modal, Paper, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useCallback, useEffect, useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import service from "../Helpers/gifservices";
import { recommendedBy, refereeStatus } from "../Constants";
import ScoreAccordionTable from "./refereesStatusTables/ScoreAccordionTable";
import DetailsAccordionTable from "./refereesStatusTables/DetailsAccordionTable";
import SimpleAccordionTable from "./refereesStatusTables/SimpleAccordionTable";
import { useLoading } from "../../../providers/loadingProvider";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: "80%",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #000",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `5%`,
    left: `10%`,
    overflowX: "auto",
    height: "90%",
  },
  closeIcon: {
    float: "right",
    top: -20,
    right: -30,
  },
  typography: {
    fontWeight: 500,
    fontSize: 16,
  },
  typography2: {
    fontWeight: 600,
    fontSize: 17,
    marginLeft: 10,
  },
}));

export default function RefereesStatus(props) {
  const classes = useStyles();
  const loading = useLoading();
  const { open, onClose, proposal } = props;
  const [proposalReferees, setProposalReferees] = useState({
    agreed: [],
    invited: [],
    potential: [],
    declined: [],
    nosend: [],
  });

  const getProposalReferees = useCallback(async () => {
    const loadingId = loading.addLoading("Loading reviewer status");
    const proposalId = proposal.id;
    var proposalReferees = await service.GetProposalRefereeForProposal({
      proposalId,
    });
    const nosend = proposalReferees.filter(
      (pr) => pr.recommendedBy === recommendedBy.ApplicantReviewerNotToBeSent
    );
    proposalReferees = proposalReferees.filter(
      (pr) => pr.recommendedBy !== recommendedBy.ApplicantReviewerNotToBeSent
    );
    const agreed = proposalReferees.filter(
      (pr) =>
        pr.statusCode === refereeStatus.agreeToEvaluate ||
        pr.statusCode === refereeStatus.evaluationReceivedFromReferee ||
        pr.statusCode === refereeStatus.evaluationEmailReminder
    );
    const invited = proposalReferees.filter(
      (pr) =>
        pr.statusCode === refereeStatus.sentFirstMail ||
        pr.statusCode === refereeStatus.sentFirstMailReminder ||
        pr.statusCode === refereeStatus.firstEmailSpecialReminder
    );
    const potential = proposalReferees.filter(
      (pr) => pr.statusCode === refereeStatus.potential
    );
    const declined = proposalReferees.filter(
      (pr) => pr.statusCode === refereeStatus.declinedEvaluating
    );

    setProposalReferees({ nosend, agreed, invited, potential, declined });
    loading.removeLoading(loadingId);
  }, [proposal, loading]);

  useEffect(() => {
    if (!open) return;
    getProposalReferees();
  }, [proposal, open, getProposalReferees]);

  return (
    <Modal open={open} onClose={onClose}>
      <Paper className={classes.paper}>
        <IconButton className={classes.closeIcon} onClick={onClose} size="large">
          <CancelIcon style={{ fontSize: 25 }} />
        </IconButton>
        <Box display="flex" marginBottom={5}>
          <Typography
            className={classes.typography}
          >{`Reviewers Status for Proposal:`}</Typography>
          <Typography className={classes.typography2}>
            {proposal.name}
          </Typography>
        </Box>
        <ScoreAccordionTable
          name="Reviewers that agreed to evaluate"
          proposalReferees={proposalReferees.agreed}
        />
        <DetailsAccordionTable
          name="Reviewers invited to evaluate"
          proposalReferees={proposalReferees.invited}
        />
        <DetailsAccordionTable
          name="Potential Reviewers"
          proposalReferees={proposalReferees.potential}
        />
        <SimpleAccordionTable
          name="Reviewers who declined invitation"
          proposalReferees={proposalReferees.declined}
        />
        {/* <SimpleAccordionTable
          name="Reviewers that should not be invited to evaluate proposal"
          proposalReferees={proposalReferees.nosend}
        /> */}
      </Paper>
    </Modal>
  );
}
